/* global fetch */
import 'isomorphic-fetch'
import { isObjectEmpty } from 'tools/object'

export default async (url, options = { credentials: 'include' }, autoParse = true) => {
  const response = await fetch(url, options)

  if (response.status >= 200 && response.status < 300) {
    if (!autoParse) {
      return response
    }

    const json = await response.json()
    if (json.redirect) {
      window.location.href = json.redirect
    }

    return json
  } else {
    if (options && options.method === 'HEAD') {
      throw new Error(response.status)
    }

    const json = await response.json()
    if (isObjectEmpty(json)) {
      throw new Error(`Unexpected error while fetching with ${url} with options ${JSON.stringify(options, null, 2)}`)
    }

    throw json
  }
}
